<template>
    <transition name="fade">
      <div v-if="visible" class="mess_user">
        <img :src="qHand(messData.avatar)" class="hand"/>
        <div class="rt">
          <div class='name'>{{messData.name}}</div>
          <div class="says" v-html="messData.content"></div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      messData:{
        type:Object,
        default:()=>{
          return {
            name:'',
            content:'',
            avatar:''
          }
        }
      },
      duration: {
        type: Number,
        default: 3000
      }
    },
    data() {
      return {
        visible: true
      };
    },
    methods:{
        qHand(val){
          if(val){
            return val; 
          }else{
            return require('@/assets/images/aqghand.png')
          }
        }
    },
    mounted() {
      setTimeout(() => {
        this.visible = false;
      }, this.duration);
    }
  };
  </script>
  
  <style scoped>
  .mess_user {
    /* 添加你的样式 */
    position: fixed;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    box-shadow: 0 0 10px #eee;
    color: #fff;
    padding: 10px 20px;
    border-radius: 4px;
    display: flex;
    z-index: 99999;
    .hand {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      border-radius:10px;
    }
    .rt{
      width:150px;
      .name{
        margin-bottom: 2px;
        font-size: 16px;
        color:#333;
        line-height: 20px;
        font-weight: bold;
      }
    }
    .says {
      font-size: 12px;
      color:#666;
      line-height: 18px;
      height: 36px;
      display: -webkit-box;
     -webkit-box-orient: vertical;
     -webkit-line-clamp: 2;
     overflow: hidden;
    }
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
  </style>